import { useRef } from 'react';
import { sendAnalyticsEvent } from '../api/publishApi';

export const useContentAnalytics = () => {
    const dispatchInteractionEvent = (eventName, post, viewDurationSeconds = null) => {
        if (!post) return;
        
        // Only handle events for video and audio, not for images
        if (post.content_type !== 'video' && post.content_type !== 'audio') {
            return;
        }

        const payload = {
            event_name: eventName,
            content_id: post.content_id || post.id || '',
            compliance_id: post.compliance_id || null
        };

        if (eventName === 'content_viewed' && viewDurationSeconds !== null) {
            payload.view_duration_seconds = viewDurationSeconds;
        }

        sendAnalyticsEvent(payload).catch(e => {
            console.error(`Failed to send analytics event: ${eventName}`, e);
        });
    };

    return { dispatchInteractionEvent };
};

export const useViewDurationTracker = (dispatchInteractionEvent) => {
    const viewStartTimeRefs = useRef(new Map());

    const startTracking = (id) => {
        if (!id) return;
        viewStartTimeRefs.current.set(id, Date.now());
    };

    const stopTracking = (id, post) => {
        if (!id || !post) return;
        const startTime = viewStartTimeRefs.current.get(id);
        if (startTime) {
            const durationWatched = (Date.now() - startTime) / 1000;
            // Only fire if they watched for at least 0.5s to avoid accidental micro-views
            if (durationWatched > 0.5) {
                dispatchInteractionEvent('content_viewed', post, durationWatched);
            }
            viewStartTimeRefs.current.delete(id);
        }
    };

    return { startTracking, stopTracking };
};
